import { render, staticRenderFns } from "./RefundGoodsList.vue?vue&type=template&id=3e86f3a4"
import script from "./RefundGoodsList.vue?vue&type=script&lang=js"
export * from "./RefundGoodsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports